import {
  CircularProgress,
  Container,
  Typography,
  Box
} from '@mui/material'
import React from 'react'

type Props = {
  title: string;
}

const LoadingPage = (props: Props) => {
  const { title } = props
  return (
    <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
        <CircularProgress size={50} title='Loading' />
        <Typography color="primary">{title}</Typography>
      </Box>
    </Container>
  )
}

export default LoadingPage